export const settingsCs = {
  'Account': 'Účet',
  'Profile': 'Profil',
  'Security': 'Zabezpečení',
  'Integrations': 'Integrace',
  'LinkedIn Accounts': 'LinkedIn účty',
  'Connect LinkedIn': 'Připojit LinkedIn',
  'No accounts connected yet.': 'Zatím není připojen žádný účet.',
  'Connect an account to sync your inbox.': 'Připojte účet pro synchronizaci schránky.',
  'Knowledge Base': 'Znalostní báze',
  'Add grounded client facts for AI replies. Text and explicit URLs only in this POC.': 'Přidejte ověřené informace klienta pro odpovědi AI. V této verzi lze použít text a konkrétní URL.',
  'Starter templates': 'Úvodní šablony',
  'Insert as text note': 'Vložit jako textovou poznámku',
  'Text note': 'Textová poznámka',
  'URL page': 'Webová stránka',
  'Knowledge text': 'Text znalosti',
  'Add source': 'Přidat zdroj',
  'Reindex': 'Znovu indexovat',
  'Not indexed yet': 'Zatím neindexováno',
  'Last indexed': 'Naposledy indexováno',
  'Chunks': 'Části',
  'Services and Scope': 'Služby a rozsah',
  'AI Reply Rules': 'Pravidla odpovědí AI',
  'Approved Example Replies': 'Schválené příklady odpovědí',
  'AI Auto-Reply is currently disabled.': 'Automatické odpovědi AI jsou momentálně vypnuté.',
  'AI Auto-Reply is enabled.': 'Automatické odpovědi AI jsou zapnuté.',
  'Runtime diagnostics': 'Diagnostika běhu',
  'Blocked by settings': 'Blokováno nastavením',
  'Tone of voice': 'Tón komunikace',
  'Professional': 'Profesionální',
  'Friendly': 'Přátelský',
  'Casual': 'Neformální',
  'Response delay': 'Zpoždění odpovědi',
  'Working hours': 'Pracovní doba',
  'Require approval': 'Vyžadovat schválení',
  'Confidence threshold': 'Práh jistoty',
  'Fallback message': 'Náhradní zpráva',
  'Custom instructions': 'Vlastní instrukce',
  'Auto Outreach': 'Automatický outreach',
  'Daily limit': 'Denní limit',
  'Outreach template': 'Šablona outreach',
  'Two-factor authentication': 'Dvoufaktorové ověření',
  'Change password': 'Změnit heslo',
  'Current password': 'Současné heslo',
  'New password': 'Nové heslo',
  'Enable 2FA': 'Zapnout 2FA',
  'Disable 2FA': 'Vypnout 2FA',
  'Recovery codes': 'Obnovovací kódy',
  'Save settings': 'Uložit nastavení',
  'Settings saved': 'Nastavení uloženo',
  'Connection failed': 'Připojení se nezdařilo',
  'Your account information': 'Informace o vašem účtu',
  'Password and authenticator app protection': 'Ochrana heslem a autentizační aplikací',
  'Confirm new password': 'Potvrďte nové heslo',
  'Add this account in your authenticator app, then enter the 6-digit code.': 'Přidejte tento účet do autentizační aplikace a poté zadejte šestimístný kód.',
  'Manual secret': 'Ruční klíč',
  'Authenticator URI': 'URI autentizátoru',
  'Save these recovery codes now. They are shown once.': 'Uložte si nyní tyto obnovovací kódy. Zobrazí se pouze jednou.',
  'OpenAI Integration': 'Integrace OpenAI',
  'Used for AI-powered drafts and replies': 'Používá se pro návrhy a odpovědi vytvářené AI',
  'OpenAI API Key': 'API klíč OpenAI',
  'AI is managed by your admin': 'AI spravuje váš administrátor',
  'No knowledge sources yet.': 'Zatím nejsou přidány žádné zdroje znalostí.',
  'AI will stay strict and conservative until you add grounded sources.': 'Dokud nepřidáte ověřené zdroje, AI zůstane přísná a konzervativní.',
  'Indexing error': 'Chyba indexování',
  'Connect via Unipile hosted auth': 'Připojení přes zabezpečenou autorizaci Unipile',
  'Backend config': 'Konfigurace backendu',
  'Configure when and how AI responds': 'Nastavte, kdy a jak má AI odpovídat',
  'Effective mode': 'Aktivní režim',
  'Last auto-sync': 'Poslední automatická synchronizace',
  'Next pending reply': 'Další čekající odpověď',
  'Latest skip or failure': 'Poslední přeskočení nebo chyba',
  'Knowledge readiness': 'Připravenost znalostí',
  'Knowledge issue': 'Problém se znalostmi',
  'Recommended for KB mode': 'Doporučeno pro režim znalostní báze',
  'Tone': 'Tón',
  'Trigger on': 'Spustit při',
  'Existing unresolved chats': 'Existující nevyřešené konverzace',
  'Generate pending drafts for chats marked Needs Reply.': 'Vytvořit čekající návrhy pro konverzace označené jako Vyžaduje odpověď.',
  'Replies are sent as': 'Odpovědi se odesílají jako',
  'Quiet window': 'Klidové okno',
  'Random between': 'Náhodně mezi',
  'minutes': 'minut',
  'and': 'a',
  'From': 'Od',
  'To': 'Do',
  'Require human approval': 'Vyžadovat schválení člověkem',
  'How would you like to approve drafts?': 'Jak chcete schvalovat návrhy?',
  'In-app approval queue': 'Fronta schvalování v aplikaci',
  'Drafts wait in Linirio until you approve them.': 'Návrhy čekají v Linirio, dokud je neschválíte.',
  'Email me with Yes / No buttons': 'Poslat e-mail s tlačítky Ano / Ne',
  'Approve from your inbox without opening Linirio.': 'Schvalte návrh přímo z e-mailu bez otevření Linirio.',
  'When confidence is below threshold': 'Když je jistota pod nastavenou hranicí',
  'Use fallback message': 'Použít náhradní zprávu',
  'Safest for auto-send if you want a controlled default reply.': 'Nejbezpečnější volba pro automatické odesílání s řízenou výchozí odpovědí.',
  'Send draft to Approvals': 'Odeslat návrh ke schválení',
  'Good when AI produced something usable, but you want a human to review weaker cases.': 'Vhodné, když AI vytvořila použitelný text, ale slabší případy má zkontrolovat člověk.',
  'Skip reply': 'Přeskočit odpověď',
  'Most conservative option. Nothing is sent if confidence is too low.': 'Nejkonzervativnější možnost. Při nízké jistotě se nic neodešle.',
  'Fallback message (optional)': 'Náhradní zpráva (volitelné)',
  'Custom instructions (optional)': 'Vlastní instrukce (volitelné)',
  'Automatic first-touch outreach to new leads': 'Automatické první oslovení nových leadů',
  'Message template': 'Šablona zprávy',
  'Delay (minutes)': 'Prodleva (minuty)',
  'Max per day': 'Maximum za den',
  'LinkedIn connected. Finalizing account setup...': 'LinkedIn je připojen. Dokončuje se nastavení účtu...',
  'LinkedIn connected successfully. Inbox is syncing...': 'LinkedIn byl úspěšně připojen. Schránka se synchronizuje...',
  'Google Calendar connected successfully.': 'Google Kalendář byl úspěšně připojen.',
  'LinkedIn connection failed. Please try again.': 'Připojení LinkedIn se nezdařilo. Zkuste to znovu.',
  'Knowledge source updated. Reindexing started.': 'Zdroj znalostí byl aktualizován. Začalo nové indexování.',
  'Knowledge source added. Indexing started.': 'Zdroj znalostí byl přidán. Začalo indexování.',
  'Knowledge source deleted.': 'Zdroj znalostí byl smazán.',
  'Enter your current and new password.': 'Zadejte současné a nové heslo.',
  'New password confirmation does not match.': 'Potvrzení nového hesla se neshoduje.',
  'Password changed successfully.': 'Heslo bylo úspěšně změněno.',
  'Two-factor authentication is enabled.': 'Dvoufaktorové ověření bylo zapnuto.',
  'Two-factor authentication is disabled.': 'Dvoufaktorové ověření bylo vypnuto.',
  'Google Calendar disconnected.': 'Google Kalendář byl odpojen.',
  'Remove your OpenAI API key?': 'Odebrat váš API klíč OpenAI?',
  'Disconnect this account?': 'Odpojit tento účet?',
  'Disable two-factor authentication?': 'Vypnout dvoufaktorové ověření?',
  'Disconnect Google Calendar?': 'Odpojit Google Kalendář?',
  'Engagement Voice': 'Hlas pro zapojení',
  'Define how public LinkedIn comments should sound. This is separate from Inbox AI Auto-Reply.': 'Nastavte, jak mají znít veřejné komentáře na LinkedInu. Toto nastavení je oddělené od AI odpovědí ve schránce.',
  'Describe your voice': 'Popište svůj hlas',
  'Example: Direct, practical, occasionally dry humor. Avoid praise and corporate language.': 'Příklad: Přímý, praktický, občas se suchým humorem. Bez pochvalných a korporátních frází.',
  'Directness': 'Přímost',
  'Diplomatic': 'Diplomatický',
  'Straight to the point': 'Přímo k věci',
  'Humor': 'Humor',
  'Serious': 'Vážný',
  'Playful when appropriate': 'Hravý, když se to hodí',
  'Human touch': 'Lidskost',
  'Neutral': 'Neutrální',
  'Natural and personal': 'Přirozený a osobní',
  'Preferred length': 'Preferovaná délka',
  'Very short': 'Velmi krátká',
  'More developed': 'Rozvinutější',
  'Voice preview': 'Náhled hlasu',
  'The draft will lead with a useful point, use natural language, and add humor only when the post supports it.': 'Návrh začne užitečnou myšlenkou, použije přirozený jazyk a humor přidá jen tehdy, když se k příspěvku hodí.',
  'Manual style examples': 'Ruční příklady stylu',
  'Manual examples are prioritized. Successfully sent comments are learned automatically.': 'Ruční příklady mají přednost. Úspěšně odeslané komentáře se systém učí automaticky.',
  'sent examples learned': 'odeslaných příkladů naučeno',
  'Paste a comment that sounds like you.': 'Vložte komentář, který zní jako vy.',
  'Add example': 'Přidat příklad',
  'Remove example': 'Odebrat příklad',
  'This example is already added.': 'Tento příklad už je přidaný.',
  'Engagement Voice saved.': 'Hlas pro zapojení byl uložen.',
  'Save Engagement Voice': 'Uložit hlas pro zapojení',
  'Saving...': 'Ukládání...',
};
